import './Open-In-Github.svelte.css.proxy.js';
/* src/components/Open-In-Github.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import { faGithub } from "../_snowpack/pkg/@fortawesome/free-brands-svg-icons.js";
import Icon from "./Icon.svelte.js";

function create_fragment(ctx) {
	let a;
	let icon;
	let t0;
	let span;
	let t1;
	let current;

	icon = new Icon({
			props: { class: "large", icon: faGithub }
		});

	return {
		c() {
			a = element("a");
			create_component(icon.$$.fragment);
			t0 = space();
			span = element("span");
			t1 = text("Open in Github");
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", {
				href: true,
				class: true,
				target: true,
				rel: true
			});

			var a_nodes = children(a);
			claim_component(icon.$$.fragment, a_nodes);
			t0 = claim_space(a_nodes);
			span = claim_element(a_nodes, "SPAN", {});
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, "Open in Github");
			span_nodes.forEach(detach);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", /*url*/ ctx[0]);
			attr(a, "class", "btn-github svelte-1k1nv0v");
			attr(a, "target", "_blank");
			attr(a, "rel", "external");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			mount_component(icon, a, null);
			append(a, t0);
			append(a, span);
			append(span, t1);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*url*/ 1) {
				attr(a, "href", /*url*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(a);
			destroy_component(icon);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { url = "" } = $$props;

	$$self.$$set = $$props => {
		if ("url" in $$props) $$invalidate(0, url = $$props.url);
	};

	return [url];
}

class Open_In_Github extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { url: 0 });
	}
}

export default Open_In_Github;
//# sourceMappingURL=Open-In-Github.svelte.js.map
